import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import SwipeableTextMobileStepper from "./MobileStepper";
import { SecondaryStyle } from "../fonts";

import RD from "../assets/Page1RD.webp";

import LD from "../assets/Page1LD.webp";
import LCT from "../assets/Page1LCT.webp";
import LCB from "../assets/Page1LCB.webp";
import RB1 from "../assets/Page1RB1.webp";
import RB2 from "../assets/Page1RB2.webp";
import RB3 from "../assets/Page1RB3.webp";

//@ts-ignore
import RA from "../assets/Page1RA.mp4";
//@ts-ignore
import LB from "../assets/Page1LB.mp4";

const carousel1Images = [RB1, RB2, RB3];

const Page1 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{
                height: "100%",
                borderTop: { xs: "1vh solid #fff", sm: "none" },
              }}
            >
              {/* LA/LD */}
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                    width: "100%",
                    maxHeight: { xs: "100%", sm: "50vh" },
                  }}
                >
                  {/* LC */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      height: {
                        xs: "45vh",
                        sm: "100%",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      maxHeight: "50vh",
                      borderBottom: ".5vh solid #fff",
                      backgroundImage: `url('${LD}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                    }}
                  />

                  {/* LB */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                      pb: { xs: 1.5 },
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        ...SecondaryStyle,

                        textAlign: { xs: "justify", sm: "left" },
                        "@media (orientation: landscape)": {
                          fontSize: { xs: "1vw", md: "1vw", lg: "0.95vw" },
                          lineHeight: {
                            xs: "1.5vw",
                            md: "1.5vw",
                            lg: "1.5vw",
                          },
                        },
                        "@media (orientation: portrait)": {
                          fontSize: { xs: "1.7vh", sm: "1vh" },
                          lineHeight: {
                            xs: "2vh",
                            sm: "1.5vh",
                            md: "1.5vh",
                            lg: "1.5vh",
                          },
                          paddingTop: {
                            xs: "1vh",
                            sm: "2vh",
                            md: "2vh",
                            lg: "2vh",
                          },
                        },
                      }}
                    >
                      Step into this stylish laneway house, where modern design
                      meets cozy charm. The sleek exterior, surrounded by lush
                      greenery, sets a tranquil tone as you enter. Inside, the
                      entryway welcomes you with its bright and inviting
                      atmosphere, seamlessly flowing into a sunlit dining area.
                      Large windows flood the space with natural light,
                      highlighting the room's clean lines and open layout,
                      perfect for both relaxed meals and intimate gatherings.
                      Every detail in this thoughtfully designed home enhances
                      its modern, comfortable feel—ideal for people looking for
                      a unique urban living experience.
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/** */}
              <Grid item xs={12} sm={6}>
                <Grid container direction={"row"} sx={{ height: "100%" }}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderTop: ".5vh solid #fff",

                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },

                      height: {
                        xs: "93.8vh",
                        sm: "100%",
                      },
                      maxHeight: { xs: "100%", sm: "50vh" },
                    }}
                  >
                    <Box
                      sx={{
                        height: { xs: "46vh", sm: "24.1vh" },
                        borderRadius: { xs: "16px", sm: "0vh" },

                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        backgroundImage: `url('${LCT}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />

                    <Box
                      sx={{
                        height: { xs: "45.5vh", sm: "24.5vh" },

                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: ".5vh solid #fff",
                        backgroundImage: `url('${LCB}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      maxHeight: "50vh",
                      borderTop: ".5vh solid #fff",

                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderBottom: {
                        xs: ".5vh solid #fff",
                        sm: "none",
                      },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: {
                          xs: "45vh",
                          sm: "100%",
                        },
                        maxHeight: "50vh",

                        objectFit: "cover",
                      }}
                      src={LB}
                      playsInline
                      autoPlay
                      muted
                      loop
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    height: "100%",
                  }}
                >
                  {/* RD/RA */}
                  <Grid
                    container
                    direction={"row"}
                    sx={{
                      height: "100%",
                    }}
                  >
                    {/* RD */} {/* RA */}
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        height: {
                          xs: "45vh",
                          sm: "100%",
                        },
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: "none",
                        },
                        borderBottom: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        backgroundImage: `url('${RD}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",

                        maxHeight: { xs: "100%", sm: "50vh" },
                      }}
                    />
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      sx={{
                        maxHeight: "50vh",
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: "none",
                        },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderBottom: ".5vh solid #fff",
                      }}
                    >
                      <CardMedia
                        component={"video"}
                        sx={{
                          borderRadius: { xs: "16px", sm: "0vh" },
                          height: {
                            xs: "45vh",
                            sm: "100%",
                          },
                          maxHeight: "50vh",

                          objectFit: "cover",
                        }}
                        src={RA}
                        playsInline
                        autoPlay
                        muted
                        loop
                      />
                    </Grid>
                    {/**RC */}
                    <Grid
                      item
                      xs={12}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        borderTop: {
                          xs: ".5vh solid #fff",
                          sm: ".5vh solid #fff",
                        },
                        borderLeft: {
                          xs: "1vh solid #fff",
                          sm: ".5vh solid #fffe",
                        },
                        borderBottom: { xs: "1vh solid #fff", sm: "none" },
                        borderRight: {
                          xs: "1vh solid #fff",
                          sm: "none",
                        },
                        height: {
                          xs: "35.5vh",
                          sm: "50vh",
                        },
                      }}
                    >
                      <SwipeableTextMobileStepper images={carousel1Images} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page1;
